export enum ParamsEnum {
  STRING = 'string',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  ARRAY_STRING = 'array_string',
  ARRAY_NUMBER = 'array_number',
  ARRAY_BOOLEAN = 'array_boolean',
}

export type ParamsEnumMap = {
  [ParamsEnum.NUMBER]: number;
  [ParamsEnum.STRING]: string;
  [ParamsEnum.BOOLEAN]: boolean;
  [ParamsEnum.ARRAY_NUMBER]: Array<number>;
  [ParamsEnum.ARRAY_STRING]: Array<string>;
  [ParamsEnum.ARRAY_BOOLEAN]: Array<boolean>;
};
